<template lang="pug">
//- TODO 20221110 main banner
.dedicatedService.mt-30
  //- alert 提醒視窗
  alert
  .container
    .desktopContent
      .container.px-0
        .text-center
          img.img-fluid.mainBanner(src="../assets/img/dedicatedService/a02.jpg")
      .container-fluid.serviceBox
        //- .row.align-items-center.flex-column.mx-0
        //-   .row.serviceDes.mx-0.justify-content-center
        .row.serviceDes.flex-row.mx-0.align-items-center.justify-content-center
            .col-4.m-5.px-1
              img.img-fluid(src="../assets/img/dedicatedService/b01.png")
            .col-4.m-5.px-1
              img.img-fluid(src="../assets/img/dedicatedService/b02.png")
            .col-4.m-5.px-1
              img.img-fluid(src="../assets/img/dedicatedService/b03.png")
      .container-fluid.w-75
        .d-flex.my-3.flex-column.align-items-center
          p.text-center.font-weight-bold.eachTitle.px-5 特製/企業大量客製訂單
        .d-flex.m-0.flex-column.align-items-center
          p.text-center.font-weight-bold.w-100.eachSecondTitle.px-2 我們致力於提供完美的印刷體驗 滿足您的多樣化需求
        .d-flex.mb-3.flex-column.align-items-center
          p.text-left.w-100.eachDes.px-2 感謝您對永豐雲端印刷網的支持。不管是現行商品大量印製、商品特殊需求、新商品詢問，都請撥空填寫下方表格，讓專人更快了解，與您聯繫。您的肯定，是永豐不斷進步的動力！
        .d-flex.align-items-center.mb-3
          .col-md-3
            p.text-right 姓名/公司
          .col-md-9
            input(type="text" v-model="contactInfo.name").form-control.rounded-0
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.name === '' && emptyInput.indexOf(0) > -1") 此欄位必填
        .d-flex.align-items-center.mb-3
          .col-md-3
            p.text-right 電話/手機
          .col-md-9
            input(type="text" v-model="contactInfo.phone").form-control.rounded-0
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.phone === '' && emptyInput.indexOf(1) > -1") 此欄位必填
        .d-flex.align-items-center.mb-3
          .col-md-3
            p.text-right Email
          .col-md-9
            input(type="text" v-model="contactInfo.email").form-control.rounded-0
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.email === '' && emptyInput.indexOf(2) > -1") 此欄位必填
        .d-flex.align-items-center.mb-3
          .col-md-3
            p.text-right 您的留言
          .col-md-9
            textarea(name="" id="" cols="30" rows="10" v-model="contactInfo.message" placeholder="請描述需求的產品、數量、特殊要求").form-control.rounded-0
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.message === '' && emptyInput.indexOf(3) > -1") 此欄位必填
        .d-flex.align-items-center.mb-3
          .col-md-3
          .col-md-9
            p 如一直收不到回覆信件，請查明您的垃圾信件夾匣，並將 services@mail.cloudw2p.com 加入通訊錄喔！上列您填入的資料，僅在雲端印刷網上交易使用，不會作為其他用途使用。以上資料請仔細填寫，聯絡將以此資料為主，謝謝您的填寫。
        //- 20221114 按鈕修改
        .d-flex.mb-3
          .col-md-3
            p.text-right 驗證碼
          .col-md-9
            .d-flex.flex-wrap
              div.mr-auto
                input.ml-3.rounded-0(type="text" v-model="contactInfo.captcha").captchaInput.mx-auto
              div.mb-1
                img.verifyImg(:src="verifyImg")
              div.ml-auto
                button.btn.btn-primary.font-weight-bold.btnInPage.px-0.py-0.text-decoration-none(@click="getImage") 重產驗證碼
        .d-flex.justify-content-end.mb-3
          .col-md-3
          .col-md-9
            .d-flex.justify-content-end
              button.btn.btn-primary.font-weight-bold.btnInPage.px-0.py-0.text-decoration-none(@click="contactus(), gtag_report_conversion ()") 確認送出 <i class="fas fa-chevron-right fa-xs"></i>
    //- mobile看到的樣子
    .mobileContent.pl-0
      .container.px-0
        .text-center
          img.img-fluid.mainBanner(src="../assets/img/dedicatedService/a03.jpg")
      .container-fluid.serviceBox
        .row.serviceDes.flex-column.mx-0.align-items-center.justify-content-center
          .col-12.m-3.px-1
            img.img-fluid(src="../assets/img/dedicatedService/b01.png")
          .col-12.m-3.px-1
            img.img-fluid(src="../assets/img/dedicatedService/b02.png")
          .col-12.m-3.px-1
            img.img-fluid(src="../assets/img/dedicatedService/b03.png")
      .container-fluid
        .d-flex.my-3.flex-column.align-items-center
          p.text-center.font-weight-bold.eachTitle.px-3 特製/企業大量客製訂單
        .d-flex.m-0.flex-column.align-items-center
          p.text-center.font-weight-bold.w-100.eachSecondTitle.px-2 我們致力於提供完美的印刷體驗 滿足您的多樣化需求
        .d-flex.mb-3.flex-column.align-items-center
          p.text-left.w-100.eachDes.px-2 感謝您對永豐雲端印刷網的支持。不管是現行商品大量印製、商品特殊需求、新商品詢問，都請撥空填寫下方表格，讓專人更快了解，與您聯繫。您的肯定，是永豐不斷進步的動力！
        .d-flex.mb-3.flex-column.align-items-start
          .col-4.px-0.d-flex.align-items-center
            p.text-right.mb-0 姓名/公司
          .col-12.px-1.d-flex.flex-column.align-items-start
            input.border-dark.form-control.rounded-0(type="text" v-model="contactInfo.name")
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.name === '' && emptyInput.indexOf(0) > -1") 此欄位必填
        .d-flex.mb-3.flex-column.align-items-start
          .col-4.px-0.d-flex.align-items-center
            p.text-right.mb-0 電話/手機
          .col-12.px-1.d-flex.flex-column.align-items-start
            input.border-dark.form-control.rounded-0(type="text" v-model="contactInfo.phone")
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.phone === '' && emptyInput.indexOf(1) > -1") 此欄位必填
        .d-flex.mb-3.flex-column.align-items-start
          .col-4.px-1.d-flex.align-items-center
            p.text-right.mb-0 Email
          .col-12.px-0.d-flex.flex-column.align-items-start
            input.border-dark.form-control.rounded-0(type="text" v-model="contactInfo.email")
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.email === '' && emptyInput.indexOf(2) > -1") 此欄位必填
        .d-flex.mb-3.flex-column.align-items-start
          .col-4.px-0.d-flex.align-items-center
            p.text-right.mb-0 您的留言
          .col-12.px-1.d-flex.flex-column.align-items-start
            textarea(cols="30" rows="10" v-model="contactInfo.message" placeholder="請描述需求的產品、數量、特殊要求").form-control.border-dark.rounded-0
            p.mb-0.text-danger.text-right.fz14(v-if="contactInfo.message === '' && emptyInput.indexOf(3) > -1") 此欄位必填
        .d-flex.mb-3.flex-column.align-items-start
          .col-4.px-0.d-flex.align-items-center
            p.mb-0 輸入驗證碼
          .col-12.px-1.d-flex.flex-column.align-items-start
            input(type="text" v-model="contactInfo.captcha").form-control.border-dark.rounded-0
            //- TODO 20221114 按鈕修改
        .d-flex.mb-3.flex-column.align-items-start
          .col-12.px-1.d-flex.align-items-center.justify-content-between
            img.captchaImg.verifyImg(:src="verifyImg")
            //- button.btn.btn-primary.font-weight-bold.btnInPage.px-0.py-0.text-decoration-none(@click="getImage") 重產驗證碼

            button.btn.btn-primary.font-weight-bold.btnInPage.px-0.py-0.text-decoration-none(@click="getImage") 重產驗證碼

        .d-flex.mb-3.flex-column.align-items-start
          .col-12.px-1.d-flex.justify-content-end
            button.btn.btn-primary.font-weight-bold.btnInPage.pr-0.py-0.text-decoration-none(@click="contactus(), gtag_report_conversion ()") 確認送出 <i class="fas fa-chevron-right fa-xs"></i>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapActions } from 'vuex'
import alert from '../components/alert'
// v-model功能
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'dedicatedServiceModules/getField',
  mutationType: 'dedicatedServiceModules/updateField'
})
export default {
  components: { VueRecaptcha, alert },
  data () {
    return {
      buttonshow: false
    }
  },
  methods: {
    ...mapActions('dedicatedServiceModules', ['contactus', 'getImage']),
    gtag_report_conversion (url) {
      window.fbq('track', 'Lead')
      var callback = function () {
        if (typeof (url) !== 'undefined') {
          window.location = url
        }
      }
      window.gtag('event', 'conversion', {
        'send_to': 'AW-10816898747/OfQ9CLK-ld0YELuN86Uo',
        'event_callback': callback
      })
      console.log('[dedicatedService] gtag_report_conversion')
      return false
    }
  },
  computed: {
    ...mapFields([
      'contactInfo',
      'emptyInput',
      'verifyImg',
      'code',
      'verifyCode'
    ])
  },
  created () {
    console.log('[dedicatedService] created')
    this.$store.commit('dedicatedServiceModules/clearContactInfo')
    this.$store.dispatch('dedicatedServiceModules/getImage')
  }
}
</script>

<style lang="scss" scoped>
$serif: "Microsoft JhengHei", "Noto Serif TC", serif;
.dedicatedService {
  margin-bottom: 200px;
}
@media (max-width: 641px) {
  .desktopContent {
    display: none;
  }
}
.fz14 {
  font-size: 14px;
}
.mainBanner2 {
  width: 100%;
  display: initial;
  text-align: center;
  background: white;
}
.mainBanner {
  max-height: 760px;
  min-width: 100%;
}
.serviceBox {
  //background: #c1bfc1;
  //padding: 20px 0;
  padding: 20px;
  box-sizing: border-box;
}
.serviceDes {
  max-width: 1300px;
  .col-4 {
    max-width: 230px;
    padding: 0;
  }
  img {
    max-width: 230px;
  }
}
@media (max-width: 640px) {
  .serviceDes {
    max-width: 1300px;
    .col-12 {
      max-width: 200px;
      padding: 0;
    }
    img {
      max-width: 100%;
    }
  }
}
.eachTitle {
  font-family: $serif;
  letter-spacing: 1px;
  font-size: 24px;
  color: #fff;
  background-color: #4a95b0;
  border-radius: 20px;
  display: inline-block;
}
.eachSecondTitle {
  font-size: 22px;
}
.eachDes {
  font-size: 20px;
}
@media (max-width: 641px) {
  .eachSecondTitle {
    font-size: 20px;
  }
}
@media (min-width: 641px) {
  .mobileContent {
    display: none;
  }
}
.btnInPage {
  border-radius: 5px;
  width: 160px;
  height: 40px;
  font-size: 20px;
  //padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-chevron-right {
    margin-left: 15px;
  }
}
.captchaInput {
  border: 1px solid black;
  height: 40px;
  width: 160px;
}
.verifyImg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/dedicatedService.vue